import * as React from "react";
import { useEffect, useRef, useState } from "react";
import { ColorRing } from 'react-loader-spinner';
import { useDispatch } from "react-redux";
import { setSubLoading } from "../../Redux/Services/AuthSlice";
import { NotificationSound } from "../CommonComponents/CommonNotification";
import { ApiCall } from "../CommonComponents/CustomHooks";
import { AutoCompleteBoxNew, FormButton } from "../CommonComponents/InputBox";
import { CommonApiData } from "../CommonComponents/EnvConfig";

const GroupMenuAccess = () => {
    const dispatch = useDispatch();
    const [CheckView, setCheckView] = useState(false);
    const [CheckEdit, setCheckEdit] = useState(false);
    const [loading, setLoading] = useState(true);
    const [CheckDel, setCheckDel] = useState(false);
    const [CheckAdd, setCheckAdd] = useState(false);
    const [CheckExp, setCheckExp] = useState(false);
    const [CheckAll, setCheckAll] = useState(false);
    const [groupNameValue, setGroupNameValue] = useState('');

    const inputrefs = useRef([]);
    const commonData = CommonApiData()

    let MPageID = '';
    const [formData, setFormData] = useState(null)

    let Request = {
        ...commonData,
        data: formData,
        "userGroupID": groupNameValue,
    }

    const handleSubmit = async () => {
        await dispatch(setSubLoading(true))
        let data = await ApiCall(`/api/User/InsertUpdateGroupUserRights`, Request)
        await dispatch(setSubLoading(false))
        await NotificationSound(data.status, data.message, data.focus, inputrefs, HandleReset)
    }

    const getData = async (user) => {
        let GetData = {
            ...commonData,
            UserGroupID: user ? user : ''
        }
        setLoading(false)
        setCheckAll(false)
        setCheckAdd(false)
        setCheckEdit(false)
        setCheckDel(false)
        setCheckExp(false)
        setCheckView(false)
        let data = await ApiCall(`/api/User/GetMenuUserGroupRight`, GetData)
        setLoading(true)
        setFormData(data.getGroupUserRightsMenu)
    };

    const ViewCheckAll = () => {
        if (CheckView === false) {
            for (let i = 0; i < formData.length; i++) {
                const updatedData = [...formData];
                updatedData[i]['view'] = true;
                setFormData(updatedData);
            }
            setCheckView(true)
        } else if (CheckView === true) {
            setCheckView(false)
            for (let i = 0; i < formData.length; i++) {
                const updatedData = [...formData];
                updatedData[i]['view'] = false;
                setFormData(updatedData);
            }
        }
    };

    const AddCheckAll = () => {
        if (CheckAdd === false) {
            for (let i = 0; i < formData.length; i++) {
                const updatedData = [...formData];
                updatedData[i]['add'] = true;
                setFormData(updatedData);
            }
            setCheckAdd(true)
        } else if (CheckAdd === true) {
            setCheckAdd(false)
            for (let i = 0; i < formData.length; i++) {
                const updatedData = [...formData];
                updatedData[i]['add'] = false;
                setFormData(updatedData);
            }
        }
    };

    const EditCheckAll = () => {
        if (CheckEdit === false) {
            for (let i = 0; i < formData.length; i++) {
                const updatedData = [...formData];
                updatedData[i]['edit'] = true;
                setFormData(updatedData);
            }
            setCheckEdit(true)
        } else if (CheckEdit === true) {
            setCheckEdit(false)
            for (let i = 0; i < formData.length; i++) {
                const updatedData = [...formData];
                updatedData[i]['edit'] = false;
                setFormData(updatedData);
            }
        }
    };

    const DelCheckAll = () => {
        if (CheckDel === false) {
            for (let i = 0; i < formData.length; i++) {
                const updatedData = [...formData];
                updatedData[i]['del'] = true;
                setFormData(updatedData);
            }
            setCheckDel(true)
        } else if (CheckDel === true) {
            setCheckDel(false)
            for (let i = 0; i < formData.length; i++) {
                const updatedData = [...formData];
                updatedData[i]['del'] = false;
                setFormData(updatedData);
            }
        }
    };

    const ExpCheckAll = () => {
        if (CheckExp === false) {
            for (let i = 0; i < formData.length; i++) {
                const updatedData = [...formData];
                updatedData[i]['exp'] = true;
                setFormData(updatedData);
            }
            setCheckExp(true)
        } else if (CheckExp === true) {
            setCheckExp(false)
            for (let i = 0; i < formData.length; i++) {
                const updatedData = [...formData];
                updatedData[i]['exp'] = false;
                setFormData(updatedData);
            }
        }
    };

    const AllCheckAll = () => {
        if (CheckAll === false) {
            for (let i = 0; i < formData.length; i++) {
                const updatedData = [...formData];
                updatedData[i]['view'] = true;
                updatedData[i]['add'] = true;
                updatedData[i]['del'] = true;
                updatedData[i]['exp'] = true;
                updatedData[i]['edit'] = true;
                updatedData[i]['all'] = true;
                setFormData(updatedData);
            }
            setCheckAll(true)
            setCheckAdd(true)
            setCheckEdit(true)
            setCheckView(true)
            setCheckDel(true)
            setCheckExp(true)

        } else if (CheckAll === true) {
            setCheckAll(false)
            setCheckAdd(false)
            setCheckEdit(false)
            setCheckDel(false)
            setCheckExp(false)
            setCheckView(false)
            for (let i = 0; i < formData.length; i++) {
                const updatedData = [...formData];
                updatedData[i]['view'] = false;
                updatedData[i]['add'] = false;
                updatedData[i]['del'] = false;
                updatedData[i]['exp'] = false;
                updatedData[i]['edit'] = false;
                updatedData[i]['all'] = false;
                setFormData(updatedData);
            }
        }
    };

    const CheckByFolderNameCheckBox = (e, index, mPageID) => {

        for (let i = 0; i < formData.length; i++) {
            const updatedData = [...formData];
            if (updatedData[i]['mPageID'] === mPageID) {
                if (e.target.checked === true) {
                    updatedData[i]['view'] = true;
                    updatedData[i]['add'] = true;
                    updatedData[i]['del'] = true;
                    updatedData[i]['exp'] = true;
                    updatedData[i]['edit'] = true;
                    updatedData[i]['all'] = true;
                }
                else {
                    updatedData[i]['view'] = false;
                    updatedData[i]['add'] = false;
                    updatedData[i]['del'] = false;
                    updatedData[i]['exp'] = false;
                    updatedData[i]['edit'] = false;
                    updatedData[i]['all'] = false;
                }
            }
            setFormData(updatedData);
        }
    }

    const HandleReset = () => {
        getData()
        setGroupNameValue('')
        inputrefs.current['txtUserId'].focus()
    }

    const RightToLeftCheck = (e, index) => {
        if (e.target.checked === true) {
            formData[index].view = true
            formData[index].add = true
            formData[index].exp = true
            formData[index].del = true
            formData[index].edit = true
        } else {
            formData[index].view = false
            formData[index].add = false
            formData[index].exp = false
            formData[index].del = false
            formData[index].edit = false
        }
    };

    const handleCheckboxChange = (pageIndex, key, e) => {
        const updatedData = [...formData];
        updatedData[pageIndex][key] = !updatedData[pageIndex][key];
        setFormData(updatedData);
    };

    useEffect(() => {
        document.title = 'Group Menu Access'
        getData();
        inputrefs.current['txtUserId'].focus()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <>
            <div className='main-card card border-0'>
                <div className='card-header mb-1'>
                    <h6 className="m-0"> {'Group Menu Access'}</h6>
                </div>
                <div className='card-body'>
                    <div className='row'>
                        <AutoCompleteBoxNew
                            id="txtUserId"
                            divclassname='mb-3 col-sm-3 cntrl-width '
                            label='Group name'
                            placeholder='Group name'
                            required={true}
                            inputrefs={inputrefs}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    inputrefs.current['btnSave'].focus()
                                }
                            }}
                            autocompleteType='GetUserGroupRight'
                            value={groupNameValue || ''}
                            onChange={async (event, newInputValue) => {
                                newInputValue = newInputValue || ''
                                if (event.type !== 'keydown') {
                                    setGroupNameValue(newInputValue);
                                    getData(newInputValue);
                                }
                            }}
                            maxLength='50'
                        />
                    </div>
                    <FormButton
                        id='btnSave'
                        inputrefs={inputrefs}
                        Export={false}
                        handleSubmit={handleSubmit}
                        handleClear={HandleReset}
                    />
                </div>
                <>
                    <div className='card-body'>
                        {loading ?
                            <div className="table-responsive">
                                {formData ?
                                    (
                                        <table className="table border">
                                            <thead>
                                                <tr className='light-bg' key={'Header'}>
                                                    <th>Folder Name</th>
                                                    <th></th>
                                                    <th>Page</th>

                                                    <th><div className="d-flex"><input className='me-1' type="checkbox" onChange={ViewCheckAll} checked={CheckView} id='View' /><label htmlFor='View' style={{ fontSize: "12px", fontWeight: "bold", color: "var(--light-text)", fontFamily: "Rubik, 'Times New Roman', serif" }}>View </label></div></th>
                                                    <th> <div className="d-flex"><input className='me-1' type="checkbox" onChange={AddCheckAll} checked={CheckAdd} disabled={!CheckView} id='Add' /><label htmlFor='Add' style={{ fontSize: "12px", fontWeight: "bold", color: "var(--light-text)", fontFamily: "Rubik, 'Times New Roman', serif" }}>Add </label> </div></th>
                                                    <th> <div className="d-flex"><input className='me-1' type="checkbox" onChange={EditCheckAll} checked={CheckEdit} disabled={!CheckView} id='Edit' /><label htmlFor='Edit' style={{ fontSize: "12px", fontWeight: "bold", color: "var(--light-text)", fontFamily: "Rubik, 'Times New Roman', serif" }}>Edit </label> </div></th>
                                                    <th> <div className="d-flex"><input className='me-1' type="checkbox" onChange={DelCheckAll} checked={CheckDel} disabled={!CheckView} id='Delete' /><label htmlFor='Delete' style={{ fontSize: "12px", fontWeight: "bold", color: "var(--light-text)", fontFamily: "Rubik, 'Times New Roman', serif" }}>Delete </label> </div></th>
                                                    <th> <div className="d-flex"><input className='me-1' type="checkbox" onChange={ExpCheckAll} checked={CheckExp} disabled={!CheckView} id='Export' /><label htmlFor='Export' style={{ fontSize: "12px", fontWeight: "bold", color: "var(--light-text)", fontFamily: "Rubik, 'Times New Roman', serif" }}>Export </label> </div></th>
                                                    <th> <div className="d-flex"><input className='me-1' type="checkbox" onChange={AllCheckAll} checked={CheckAll} id='CheckAll' /><label htmlFor='CheckAll' style={{ fontSize: "12px", fontWeight: "bold", color: "var(--light-text)", fontFamily: "Rubik, 'Times New Roman', serif" }}>CheckAll </label> </div></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    (formData)?.map((item, index) => (
                                                        <React.Fragment key={`${item.pageID}Validity`}>
                                                            {MPageID !== item.mPageID && index > 0 ?
                                                                <tr key={`${item.pageID}Validity`} style={{ background: '#feaaaa47' }}>
                                                                    <td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td></tr> : <></>}
                                                            <tr key={`${index}${item.menuName}`}>
                                                                {MPageID !== item.mPageID ?
                                                                    <><td rowSpan={item.rowSpan}
                                                                        className="text-danger fw-bold">
                                                                        {
                                                                            MPageID = item.mPageID,
                                                                            item.folderName === '' ? <></> : item.folderName
                                                                        }
                                                                    </td>
                                                                        <td rowSpan={item.rowSpan}>
                                                                            <span className="MM ">
                                                                                <input

                                                                                    name='check'
                                                                                    type="checkbox"
                                                                                    onClick={(e) => CheckByFolderNameCheckBox(e, index, item.mPageID)}
                                                                                />
                                                                            </span>
                                                                        </td></>
                                                                    : <></>}
                                                                <td style={{ paddingTop: "8px" }}>{item.menuName}</td>
                                                                <td>
                                                                    <span className="MM">
                                                                        <input
                                                                            style={{ marginTop: "4px" }}
                                                                            name='view'
                                                                            type="checkbox"
                                                                            checked={item.view}
                                                                            onChange={() => handleCheckboxChange(index, 'view')}
                                                                        />
                                                                    </span>

                                                                </td>
                                                                <td>
                                                                    <span className="MM">
                                                                        <input
                                                                            style={{ marginTop: "4px" }}
                                                                            name='add'
                                                                            type="checkbox"
                                                                            checked={item.add}
                                                                            onChange={() => handleCheckboxChange(index, 'add')}
                                                                            disabled={!formData[index].view}
                                                                        />
                                                                    </span></td>
                                                                <td>
                                                                    <span className="MM">
                                                                        <input
                                                                            style={{ marginTop: "4px" }}
                                                                            name='edit'
                                                                            type="checkbox"
                                                                            checked={item.edit}
                                                                            onChange={() => handleCheckboxChange(index, 'edit')}
                                                                            disabled={!formData[index].view}
                                                                        />
                                                                    </span>
                                                                </td>
                                                                <td><span className="MM">
                                                                    <input
                                                                        style={{ marginTop: "4px" }}
                                                                        name='del'
                                                                        type="checkbox"
                                                                        checked={item.del}
                                                                        onChange={() => handleCheckboxChange(index, 'del')}
                                                                        disabled={!formData[index].view}
                                                                    />
                                                                </span>
                                                                </td>
                                                                <td>
                                                                    <span className="MM">
                                                                        <input
                                                                            style={{ marginTop: "4px" }}
                                                                            name='exp'
                                                                            type="checkbox"
                                                                            checked={item.exp}
                                                                            onChange={() => handleCheckboxChange(index, 'exp')}
                                                                            disabled={!formData[index].view}
                                                                        />
                                                                    </span>
                                                                </td>
                                                                <td> <span className="MM">
                                                                    <input
                                                                        style={{ marginTop: "4px" }}
                                                                        name='all'
                                                                        type="checkbox"
                                                                        checked={item.all}
                                                                        onClick={(e) => RightToLeftCheck(e, index)}
                                                                        onChange={() => handleCheckboxChange(index, 'all')}
                                                                        disabled={!formData[index].view}
                                                                    />
                                                                </span>
                                                                </td>
                                                            </tr>
                                                        </React.Fragment>
                                                    ))
                                                }
                                            </tbody>
                                        </table>
                                    ) : (<></>)}
                            </div>
                            : <><center>
                                <ColorRing
                                    visible={true}
                                    height="80"
                                    width="80"
                                    ariaLabel="blocks-loading"
                                    wrapperStyle={{}}
                                    wrapperClass="blocks-wrapper"
                                    colors={['#e15b64', '#f47e60', '#f8b26a', '#abbd81', '#849b87']}
                                />
                            </center></>}
                    </div>
                </>
            </div>
        </>
    )
}
export default GroupMenuAccess;